import React, { useCallback } from "react"

import type { MetricRecordData } from "@/types/metrics/contracts"

import { TraceContextToggleCard } from "./TraceContextToggleCard"

interface TraceContextToggleProps {
  metricRecordData: MetricRecordData
  onChange: (metric: MetricRecordData) => void
}

/**
 * Whether to add matching customer OpenTelemetry traces to the judge context.
 * Independent of transcript scope: it applies to the whole conversation
 * regardless of which transcript messages the judge sees.
 */
export const TraceContextToggle: React.FC<TraceContextToggleProps> = ({
  metricRecordData,
  onChange,
}) => {
  const enabled =
    metricRecordData.metric_metadata?.trace_context?.enabled === true

  const handleChange = useCallback(
    (nextEnabled: boolean) => {
      const { trace_context: _traceContext, ...restMetadata } =
        metricRecordData.metric_metadata || {}

      onChange({
        ...metricRecordData,
        metric_metadata: nextEnabled
          ? { ...restMetadata, trace_context: { enabled: true } }
          : restMetadata,
      })
    },
    [metricRecordData, onChange],
  )

  return <TraceContextToggleCard enabled={enabled} onChange={handleChange} />
}
